import { render, staticRenderFns } from "./DepositPayMethodWarningPopup.vue?vue&type=template&id=6914c652&scoped=true&"
import script from "./DepositPayMethodWarningPopup.vue?vue&type=script&lang=js&"
export * from "./DepositPayMethodWarningPopup.vue?vue&type=script&lang=js&"
import style0 from "./DepositPayMethodWarningPopup.vue?vue&type=style&index=0&id=6914c652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6914c652",
  null
  
)

export default component.exports